__webpack_require__.p = "https://pre-prod.quickview.kindle.amazon.dev/";